import { ElementBase as a } from "@smartdesign/element-base";
import * as i from "qrcode";
const s = `<style>
	:host {
		display: flex;
	}

	:host([hidden]) {
		display: none;
	}

	#qr-code-container {
		width: 100%;
	}
</style>
<div id="qr-code-container"></div>
`, n = class n extends a {
  is() {
    return n.ID;
  }
  get data() {
    return this.getAttribute("data");
  }
  set data(t) {
    this.setAttribute("data", t);
  }
  get margin() {
    return this.hasAttribute("margin") ? parseInt(this.getAttribute("margin")) : 1;
  }
  set margin(t) {
    this.setAttribute("margin", t.toString());
  }
  static get observedAttributes() {
    return ["data", "margin"];
  }
  generate() {
    if (!this.data || !this.shadowRoot)
      return;
    const t = this.shadowRoot.getElementById("qr-code-container");
    i.toString(this.data, {
      margin: this.margin
    }).then((r) => t.innerHTML = r);
  }
  template() {
    const t = document.createElement("template");
    return t.innerHTML = s, t;
  }
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback(), this.generate();
  }
  attributeChangedCallback() {
    this.generate();
  }
};
n.ID = "sd-qrcode";
let e = n;
customElements.get(e.ID) || customElements.define(e.ID, e);
export {
  e as QRcode
};
//# sourceMappingURL=qrcode.mjs.map
